(function () {
  var modal = document.getElementById('makc-modal-notify-me');
  if (!modal) return;

  var titleEl = modal.querySelector('[data-makc-modal-notify-me-title]');
  var backdrop = modal.querySelector('[data-makc-modal-notify-me-backdrop]');
  var closeTriggers = Array.prototype.slice.call(
    modal.querySelectorAll('[data-makc-modal-notify-me-close]')
  );
  var openTriggers = Array.prototype.slice.call(
    document.querySelectorAll('[data-makc-notify-me-trigger]')
  );

  var form = modal.querySelector('.makc-modal-notify-me__form');
  var tagInput = modal.querySelector('[data-makc-notify-me-tag-input]');
  var emailInput = modal.querySelector('[data-makc-modal-notify-me-input]');
  var errorEl = modal.querySelector('[data-makc-modal-notify-me-error]');
  var contentEl = modal.querySelector('[data-makc-modal-notify-me-content]');
  var toastEl = modal.querySelector('[data-makc-modal-notify-me-toast]');
  var submitButton = modal.querySelector('[data-makc-modal-notify-me-submit]');
  var targetFrame = modal.querySelector('[data-makc-modal-notify-me-iframe]');

  // True only between triggering a real submission and handling its
  // iframe's resulting load event -- lets handleIframeLoad ignore the
  // iframe's own initial (empty) load, which fires on every page load
  // regardless of whether a submission ever happens.
  var submissionPending = false;

  // A submission can go silent forever with no error and no further
  // iframe navigation at all -- confirmed real, not hypothetical:
  // Shopify's own bot protection (hCaptcha/Cloudflare) on this endpoint
  // can block a submission outright, in which case the iframe simply
  // never re-navigates and handleIframeLoad never runs again. Without
  // this timeout the button would stay stuck on "Submitting…" forever
  // with zero feedback. 15s is generous for a normal round trip while
  // still giving up well before a real user would assume it's broken.
  var submissionTimeoutId = null;
  var SUBMISSION_TIMEOUT_MS = 15000;

  // Scroll-lock lives in the shared assets/makc-scroll-lock.js, loaded
  // once from sections/makc-menu.liquid before this script -- see that
  // file for why it's shared rather than a local implementation here.
  //
  // Always opens fresh, regardless of what was left typed/shown the last
  // time it was open -- same "reset on every open" philosophy already
  // established for the product sheet and Time Picker (both reset
  // unconditionally, not just after a successful submission). Sets the
  // dynamic tag ("notify-{handle}") here too, same dynamic-write pattern
  // already used for the title, since this is one shared modal instance
  // repopulated per product rather than one instance per product.
  function openModal(event) {
    var productTitle = event.currentTarget.getAttribute('data-product-title') || '';
    var productHandle = event.currentTarget.getAttribute('data-product-handle') || '';
    if (titleEl) titleEl.textContent = productTitle;
    if (tagInput) tagInput.value = productHandle ? 'notify-' + productHandle : '';

    if (emailInput) emailInput.value = '';
    if (errorEl) errorEl.hidden = true;
    if (contentEl) contentEl.hidden = false;
    if (toastEl) toastEl.hidden = true;
    resetSubmitButton();
    submissionPending = false;
    clearSubmissionTimeout();

    modal.hidden = false;
    window.makcScrollLock.lock();
  }

  // The modal fades out (assets/makc-modal-notify-me.css), so scroll is
  // unlocked only once it has gone -- otherwise the page behind jumps
  // back to its restored position while the modal is still visible.
  // Nothing else is reset on close: this modal rebuilds its whole state
  // on open, which is already the correct side of the transition.
  function closeModal() {
    clearSubmissionTimeout();
    modal.hidden = true;
    function tail() { window.makcScrollLock.unlock(); }
    if (window.makcOverlayExit) window.makcOverlayExit.after(modal, tail);
    else tail();
  }

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function resetSubmitButton() {
    if (!submitButton) return;
    submitButton.disabled = false;
    submitButton.classList.remove('makc-modal-notify-me__submit--disabled');
    submitButton.textContent = 'Notify me when it\'s back';
  }

  function clearSubmissionTimeout() {
    if (submissionTimeoutId === null) return;
    clearTimeout(submissionTimeoutId);
    submissionTimeoutId = null;
  }

  // Only ever does anything if nothing else has resolved the submission
  // first (handleIframeLoad clears this timeout on every real
  // resolution) -- the submissionPending guard covers the rare case
  // where the timeout and a genuine load event land in the same tick.
  function handleSubmissionTimeout() {
    submissionTimeoutId = null;
    if (!submissionPending) return;
    submissionPending = false;
    resetSubmitButton();
    showError('This is taking longer than expected, please try again.');
  }

  // Real Shopify native customer/newsletter mechanism (same {% form
  // 'customer' %} + contact[tags] approach as sections/makc-footer.liquid),
  // confirmed via a real Admin test that Shopify merges tags onto an
  // existing customer rather than overwriting or duplicating -- see the
  // liquid template's own comment for the full reasoning.
  //
  // Submitted via a genuine native form.requestSubmit() into the hidden
  // iframe (see the liquid template), not fetch() -- direct investigation
  // found fetch()-based AJAX submission against this store's /contact
  // endpoint gets blocked/challenged server-side regardless of request
  // format, reproducible on a real device (the tag never got applied at
  // all, not just a cosmetic error). A real native POST is the exact
  // mechanism already proven to work for the footer's own form. The
  // iframe keeps the visible page from navigating, same reasoning as the
  // original fetch()-based design: this is a shared single modal
  // instance, not a persistent page section.
  //
  // Validation only -- does not itself submit. Shared between both
  // listeners below so the same checkValidity() gate (novalidate hands
  // this to JS instead of the browser's native bubble, same as the
  // footer) runs regardless of entry point. Returns whether the attempt
  // is valid enough to proceed.
  function prepareSubmission() {
    if (errorEl) errorEl.hidden = true;

    if (!emailInput || !emailInput.checkValidity()) {
      showError('Please enter a valid email address');
      return false;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('makc-modal-notify-me__submit--disabled');
      submitButton.textContent = 'Submitting…';
    }
    submissionPending = true;
    clearSubmissionTimeout();
    submissionTimeoutId = setTimeout(handleSubmissionTimeout, SUBMISSION_TIMEOUT_MS);
    return true;
  }

  // Only reached for a same-origin iframe document -- see
  // handleIframeLoad's own comment for why a genuine success never gets
  // here at all (it redirects cross-origin instead, caught before this
  // is called). This function's job is narrower than it once was: read
  // whatever server-rendered error state a same-origin re-render has.
  //
  // Shopify's form.posted_successfully?/form.errors is a GLOBAL,
  // per-request result, not scoped to the specific {% form %} block that
  // was actually submitted -- a documented Shopify Liquid platform
  // limitation (Shopify/liquid#1650 and multiple Shopify Community
  // reports of "both forms show errors"/results landing on the wrong
  // form) that applies here because sections/makc-footer.liquid's own
  // {% form 'customer' %} newsletter form co-renders on every page this
  // modal does. Only one 'customer'-type form can ever be submitted per
  // request, so whichever {% form %} block DOES show a result is
  // reporting on OUR submission. Reads our own block first (data-makc-
  // modal-notify-me-state); if that's empty, falls back to the footer's
  // own existing data-state (assets/makc-footer.css/.js, unmodified) as
  // a second reader of that same global flag. The footer's own error
  // copy isn't reused (it's specific to ITS OWN validation message, not
  // ours) -- only success/failure, with our own generic fallback text
  // for a fallback-detected error.
  function readState(doc) {
    var ownEl = doc.querySelector('[data-makc-modal-notify-me-content]');
    var ownState = ownEl ? ownEl.getAttribute('data-makc-modal-notify-me-state') : null;
    if (ownState) {
      return { state: ownState, errorText: ownEl.getAttribute('data-makc-modal-notify-me-error-text') };
    }

    var footerEl = doc.querySelector('.makc-footer__newsletter-right[data-state]');
    var footerState = footerEl ? footerEl.getAttribute('data-state') : null;
    if (footerState === 'success' || footerState === 'error') {
      return { state: footerState, errorText: null };
    }

    return { state: null, errorText: null };
  }

  // Fires once per real iframe navigation, including the iframe's own
  // initial empty load -- submissionPending (set only by an actual
  // submission attempt) is what distinguishes a real result from that
  // initial no-op.
  //
  // Confirmed via real-device testing (not automatable -- Cloudflare/
  // hCaptcha block every automated attempt before reaching real
  // business logic, see git history) that a genuinely successful
  // submission redirects the iframe cross-origin, off the storefront's
  // own domain entirely -- this store uses Shopify's hosted new customer
  // accounts system, and creating a customer record hands off to that
  // hosted domain on success. contentDocument comes back null for a
  // cross-origin frame by browser design (no SecurityError needed to
  // detect it) -- there's no other reason it would ever be null here,
  // since a validation/error response is a normal same-origin Liquid
  // re-render of the current page. A same-origin doc is passed to
  // readState() to distinguish a specific server-rendered error from the
  // generic fallback.
  function handleIframeLoad() {
    if (!submissionPending) return;
    submissionPending = false;
    clearSubmissionTimeout();
    resetSubmitButton();

    var doc = null;
    try {
      doc = targetFrame.contentDocument;
    } catch (err) {
      doc = null;
    }

    if (!doc) {
      if (contentEl) contentEl.hidden = true;
      if (toastEl) toastEl.hidden = false;
      return;
    }

    var result = readState(doc);

    if (result.state === 'success') {
      if (contentEl) contentEl.hidden = true;
      if (toastEl) toastEl.hidden = false;
      return;
    }

    showError(result.errorText || 'Something went wrong, please try again.');
  }

  // Enter/"Go"-key implicit submission on the email field -- still
  // possible with a single text field and no submit button present at
  // all. Only the invalid path calls preventDefault(); a valid
  // submission is deliberately left to proceed natively into the hidden
  // iframe.
  if (form) {
    form.addEventListener('submit', function (event) {
      if (!prepareSubmission()) {
        event.preventDefault();
      }
    });
  }

  // Primary path. type="button" (see the liquid template) means this
  // click cannot trigger native submission on its own -- requestSubmit()
  // below performs the actual real native submission, which re-fires the
  // form's own submit listener above; that's harmless (prepareSubmission
  // just re-validates/re-disables) since only requestSubmit() here ever
  // triggers the real, single POST.
  if (submitButton) {
    submitButton.addEventListener('click', function () {
      if (prepareSubmission()) {
        form.requestSubmit();
      }
    });
  }

  if (targetFrame) {
    targetFrame.addEventListener('load', handleIframeLoad);
  }

  openTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', openModal);
  });

  closeTriggers.forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  if (backdrop) {
    backdrop.addEventListener('click', closeModal);
  }
})();
